



























import Vue from "vue";
export default Vue.extend({
  setup() {
    return {
      success_msg: "Successfully Applied MIP Labels for 200 Files",
      failure_msg: "Failed to apply MIP Labels",
      failures: [
        "23 files due to some unknown reason",
        "27 files due to  some other reason",
      ],
    };
  },
});
